"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResponse = exports.searchResult = exports.searchQuery = exports.searchKind = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
/**
 * البحث الموحّد فى الشركة — خانة واحدة فوق البرنامج تلاقى العميل والمورد والصنف والحساب
 * والمستند برقمه أو اسمه أو تليفونه أو رقمه الضريبى. الشاشات والإجراءات تُطابَق فى الواجهة.
 */
exports.searchKind = zod_1.z.enum([
    'customer',
    'supplier',
    'item',
    'account',
    'sales_invoice',
    'purchase_bill',
    'receipt',
    'payment',
]);
exports.searchQuery = zod_1.z
    .object({
    q: zod_1.z.string().trim().min(1).max(100),
    /** حد كل نوع — النتائج مجمّعة بالنوع. */
    limit: zod_1.z.coerce.number().int().min(1).max(20).default(6),
})
    .strict();
exports.searchResult = zod_1.z.object({
    kind: exports.searchKind,
    id: common_1.uuid,
    /** الاسم أو رقم المستند — السطر الأول. */
    title: zod_1.z.string(),
    /** الكود أو الطرف أو التليفون — السطر الثانى. */
    subtitle: zod_1.z.string().nullable(),
    date: common_1.isoDate.nullable(),
    amount: common_1.moneyString.nullable(),
    /** طرف المستند (العميل أو المورد) — لإجراءات سريعة عليه. */
    partyId: common_1.uuid.nullable(),
    /** للحساب: كوده لفتح كشفه. */
    code: zod_1.z.string().nullable(),
});
exports.searchResponse = zod_1.z.object({ results: zod_1.z.array(exports.searchResult) });
//# sourceMappingURL=search.js.map